export type SupportContactType = 'whatsapp' | 'email';

export type SupportContact = {
  id: SupportContactType;
  label: string;
  href: string;
};

export const SUPPORT_CONTACTS: SupportContact[] = [
  {
    id: 'whatsapp',
    label: '+55 48 3027-8104',
    href: 'https://wa.me/554830278104',
  },
  {
    id: 'email',
    label: 'suporte@ecustos.com.br',
    href: 'mailto:suporte@ecustos.com.br',
  },
];
